import { DataNode } from './form';
import { EvalRender, MobileLayoutNode } from './layout';

export function walkData(node: DataNode, visitor: (node: DataNode, path: string) => void, currentPath: string = ''): void {
  visitor(node, currentPath);

  if (node.properties !== undefined) {
    for (const [property, value] of Object.entries(node.properties)) {
      walkData(value, visitor, currentPath + '/properties/' + property);
    }
  }
}

// walkEval(node: EvalRender, visitor: (node: MobileLayoutNode, nodePath: string) => void): void;
export function walkEval(node: EvalRender, visitor: (node: MobileLayoutNode, nodePath: string) => void) {
  node.pages.forEach(function(e, a) {
    doWalkEval(e, '/pages/' + a, visitor);
  })
}

// todo characterize walkable node names, implement strategy here
function doWalkEval(node: any, path: any, a: (p: any, q: any) => any) {
  a(node, path);
  var children = undefined;
  var childPath: string;

  if (!node.type) {
    if (node.content) {
      doWalkEval(node.content, path + '/content', a)
    }
  }
  switch (node.type) {
    case 'Table':
      children = node.rows;
      childPath = '/rows';
      break;
    case 'Page':
      children = node.cards;
      childPath = '/cards';
      break;
    case 'Card':
    case 'View':
    case 'Alert':
      children = node.children;
      childPath = '/children';
      break;
  }

  if (!children && node.children) {
    node.children.forEach(function(row: any, i: number) {
      doWalkEval(row, path + '/children' + '/' + i, a)
    })
  } else if (children) {
    children.forEach(function(child: any, i: number) {
      doWalkEval(child, '' + path + childPath + '/' + i, a)
    })

  } else if (node.type === 'Dismissible') {
    doWalkEval(node.child, path + '/child', a)
  }
}
